"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }

  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

var _default = defaultShouldValidate;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/defaultShouldValidate.js
 ** module id = 268
 ** module chunks = 0 1
 **/